import React from 'react';
import { SVGIcon, SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { Text } from '@/components/atoms/Text';
import { Container, IconBadgeContainer } from './Badge.style';

export type BadgeProps = {
    backgroundColor: string;
    text: string;
    textColor?: string;
    fontWeight?: 'normal' | 'bold';
    whiteSpace?: 'normal' | 'nowrap';
    icon?: SVGIcons;
    iconColor?: string;
};

export const Badge: React.FunctionComponent<React.PropsWithChildren<BadgeProps>> = ({
    backgroundColor,
    text,
    textColor,
    fontWeight,
    whiteSpace,
    icon,
    iconColor,
    ...otherProps
}) => {
    if (!text) return null;

    if (icon) {
        return (
            <IconBadgeContainer
                backgroundColor={backgroundColor}
                textColor={textColor}
                fontWeight={fontWeight}
                whiteSpace={whiteSpace}
                {...otherProps}
            >
                <SVGIcon icon={icon} size={14} color={iconColor || 'currentColor'} />
                <Text text={text} weight="medium" style={{ color: textColor }} />
            </IconBadgeContainer>
        );
    }

    return (
        <Container
            backgroundColor={backgroundColor}
            textColor={textColor}
            text={text}
            fontWeight={fontWeight}
            whiteSpace={whiteSpace}
            {...otherProps}
        />
    );
};
